<template>
  <div>
    <div>
      <!-- formData.type == 4 文字组件-->
      <div class="style_box">
        <div>
          <div class="title_box">
            <div class="title_text">
              <Icon style="font-size: 20px" type="ios-arrow-down" />文字编辑
            </div>
          </div>
          <div style="margin: 10px 0">
            <Form label-position="right" :label-width="70">
              <FormItem style="margin: 0 0 10px 0" label="文字内容">
                <Input
                  v-model="formData.content.text"
                  placeholder="请输入内容"
                ></Input>
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="文字加粗">
                <Input
                  v-model="formData.content.weight"
                  placeholder="请输入内容"
                ></Input>
              </FormItem>
              <FormItem style="margin: 0 0 10px 0" label="字体样式">
                <Select v-model="formData.content.family">
                  <Option
                    v-for="item in familyList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem label="字号">
                <div class="just_sb">
                  <Input
                    v-model="formData.content.size"
                    placeholder="请输入字号"
                    style="width: 240px"
                  ></Input>
                  <ColorPicker v-model="formData.content.textColor" />
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        formData:{
            type:Object,
            default:{}
        },
        familyList:{
            type:Array,
            default:[]
        }
    },
    data() {
        return {
        }
    },
};
</script>

<style scoped>
.style_box {
  padding: 0 10px;
}
.title_box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
.title_text {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}
</style>